import React from 'react';
import moment from 'moment';
import Circular from './circular';
import CircularNfa from './circularNfa';
import Evolution from './evolutionGraph';
import AvatarImg from '../../../../public/images/nopicture.png';
import TimeLine from '../common/timeLine';

const position = obj => {
  if (obj.value || obj.value > 0) {
    let total = 138 * obj.value;
    total /= obj.total;
    total += 65;
    return total;
  }
  return 65;
};

const validateDate = (filter, date) => {
  let dateValue;
  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return moment(dateValue).format('DD-MM-YYYY');
};

const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'HIGHRISK' || severety.toUpperCase() === 'WORSE') {
    return 'red';
  } else if (severety.toUpperCase() === 'LOWRISK' || severety.toUpperCase() === 'BETTER') {
    return 'green';
  }
  return 'yellow';
};

const Main = props => {
  return (
    <section className="container-main-principal flex">
      <section className="module-box-circular">
        <div className="avatar driver">
          <img src={AvatarImg} alt="avatar" />
        </div>
        <Circular
          inRisk={props.datos.inRisk}
          currentGoalValue={props.datos.currentGoalValue}
          goalAchieved={props.datos.goalAchieved}
          nfa={props.nfa}
          language={props.language}
        />
        <CircularNfa
          inRisk={props.datos.inRisk}
          currentFatigueLevelValue={props.datos.currentFatigueLevelValue}
          goalAchieved={props.datos.goalAchieved}
          nfa={props.nfa}
          language={props.language}
        />
      </section>
      <section className="evolution">
        <Evolution
          tooltip={props.tooltip}
          graphColorRange={props.nfa.graphRange}
          data={props.datos.evolution}
        />
        {props.datos.evolution.length > 0 && (
          <span
            className={colorSeverityItem(
              props.datos.evolution[props.datos.evolution.length - 1].risk
            )}
            style={{
              bottom: position({
                total: 100,
                value: props.datos.evolution[props.datos.evolution.length - 1].averageScoreDay
              })
            }}
          >
            {props.datos.evolution[props.datos.evolution.length - 1].averageScoreDay}%
          </span>
        )}
      </section>

      <TimeLine time={props.time} />
    </section>
  );
};
export default Main;



// WEBPACK FOOTER //
// ./source/client/components/driver_nfa/main.jsx